/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

// tslint:disable-next-line: max-func-body-length

import { IAccountWelcomeTileViewProps } from '@msdyn365-commerce-modules/account-management/dist/types/modules/account-welcome-tile/account-welcome-tile';
import { Module } from '@msdyn365-commerce-modules/utilities';
import MsDyn365, { getUrlSync } from '@msdyn365-commerce/core';
import * as React from 'react';
import { IAccountWelcomeTileProps } from '../definition-extensions/account-welcome-tile.ext.props.autogenerated';
import { IAccountWelcomeTileData } from './account-welcome-tile.data';

const AccountWelcomeTileView: React.FC<IAccountWelcomeTileViewProps & IAccountWelcomeTileProps<IAccountWelcomeTileData>> = props => {
    const { AccountWelcomeTile, heading } = props;
    const { loyaltyCard } = props.data;
    const loyaltyURL = getUrlSync('loyalty', props.context.actionContext);

    /* VSI-Customization -- START If user is not authenticated then redirets  */
    if (!props.context.request.user.isAuthenticated) {
        // const signinURL = props.context.request.user.signInUrl;
        // signinURL && window.location.assign(signinURL);
    }
    // If cardNumber doesn't exist redirects him to homepage.
    if (!loyaltyCard.result?.CardNumber && props.context.request.url.requestUrl.pathname.toLowerCase() === loyaltyURL?.toLowerCase()) {
        if (MsDyn365.isBrowser) {
            // window.location.assign(getUrlSync('home', props.context.actionContext) || '');
        }
    }
    /* VSI-Customization -- END  */

    return <Module {...AccountWelcomeTile}>{heading}</Module>;
};

export default AccountWelcomeTileView;
